import React from "react";
import "./Real_spad_road.css";

export default function Real_spad_road() {
  return (
    <div className="main_real_spad_rod">
      <div className="container-fluid">
        <h1 className="lower_tkn">Triumph Token(TRH) ROADMAP</h1>
        <div className="row justify-content-around mt-4">
          <div className="col-md-3">
            <div className="road_box">
              <p>
                Set up Website with <br />
                blog & Newsletter
              </p>
            </div>
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <div className="road_box">
              <p>
                Launch App for <br /> earnings{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="row d-none d-md-block">
            <div className="line">
                <div className="circlw_road"></div>
                <div className="circlw_road1"></div>
                <div className="circlw_road2"></div>
                <div className="circlw_road3"></div>
                <div className="circlw_road4"></div>
            </div>
        </div>
        <div className="row justify-content-around last_row">
          <div className="col-md-3">
            <div className="road_box">
              <p>
                Release whitepaper to <br /> blockchain Community
              </p>
            </div>
          </div>
          <div className="col-md-3 mt-md-0 mt-3">
            <div className="road_box">
              <p>Send out newsletters </p>
            </div>
          </div>
          <div className="col-md-3 mt-md-0 mt-3">
            <div className="road_box">
              <p>Website & System Security </p>
            </div>
          </div>
        </div>
      
        <div className="row justify-content-around mt-5">
          <div className="col-md-3">
            <div className="road_box">
              <p> Talk to Big Exchanges</p>
            </div>
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <div className="road_box">
              <p>
                NFT Launch & Airdrops <br /> Distributions{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="row d-none d-md-block">
            <div className="line">
                <div className="circlw_road"></div>
                <div className="circlw_road1"></div>
                <div className="circlw_road2"></div>
                <div className="circlw_road3"></div>
                <div className="circlw_road4"></div>
            </div>
        </div>
        <div className="row justify-content-around last_row">
          <div className="col-md-3">
            <div className="road_box">
              <p>
              Clarify Legal Questions
              </p>
            </div>
          </div>
          <div className="col-md-3 mt-md-0 mt-3">
            <div className="road_box">
              <p>Crowdfunding launch <br /> for ICO</p>
            </div>
          </div>
          <div className="col-md-3 mt-md-0 mt-3">
            <div className="road_box">
              <p>Dapps developments For <br /> Staking & rewards</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
